import { createReducer } from "redux-act";
export default function createMergedDefaultStateReducer(handlers, defaultState) {
  const reducer = createReducer(handlers, defaultState);
  function enhancedReducer(newState = defaultState, action) {
    const stateToUse = action && (action.type === "VECTOR_EDITOR_UPDATE" || action.meta && action.meta.mergeStateDeep) ? {
      ...defaultState,
      ...newState
    } : newState;
    return reducer(stateToUse, action);
  }
  enhancedReducer.__shouldUseMergedState = true;
  return enhancedReducer;
}
